import 'core-js';
import React, { Component } from 'react';
import DocumentTitle from 'react-document-title';
import {  Switch, Route  } from 'react-router-dom';

import DGRApp from '../DGR/App/App.js';
import DGRModal from '../DGR/Modal/Modal.js';

import Analytics from '../Analytics/Analytics';


import './App.css';

class App extends Component {
    render() {
        return (
            <div className="App">
                <header>
                <meta name="viewport" content="width=device-width" />
                </header>
                <DocumentTitle title='24GO'>
                <Switch basename="/go/dgr"  >
                    <Route  path="/" component={DGRApp} />
                </Switch>
                </DocumentTitle>
                <DGRModal history={this.props.history}/>
                <Analytics />
        </div>
        );
  }
}


export default App;




// WEBPACK FOOTER //
// ./src/components/App/App.js